import SvgIcon, { SvgIconProps } from "@material-ui/core/SvgIcon";
import * as React from "react";

export const DownloadIcon = (props: SvgIconProps) => {
    const { viewBox = "0 0 20 20", ...rest } = props;

    return (
        <SvgIcon viewBox={viewBox} {...rest}>
            <g>
                <rect
                    style={{
                        fill: "currentColor",
                    }}
                    x="3.73"
                    y="15.9"
                    width="12.55"
                    height="1.2"
                />
                <polygon
                    style={{
                        fill: "currentColor",
                    }}
                    points="10 15.25 4.02 10.33 4.78 9.4 10 13.69 15.09 9.42 15.86 10.34 10 15.25"
                />
                <rect
                    style={{
                        fill: "currentColor",
                    }}
                    x="9.4"
                    y="2.66"
                    width="1.2"
                    height="11.79"
                />
                <rect
                    style={{
                        fill: "none",
                    }}
                    width="20"
                    height="20"
                />
            </g>
        </SvgIcon>
    );
};
